module.exports = "https://redage.akamaized.net/src/views/player/menu/elements/fractions/elements/tasks/images/3.png";